<template>
  <b-modal title="Lista de Medições" v-model="show" size="lg">
    <div class="modal-screen-list">
      <!-- :::::::::::::::::::::::::::: TABELA DE TEMPLATES :::::::::::::::::::::::::::: -->
      <b-table
        id="table-medicao-temp"
        bordered
        hover
        small
        head-variant="light"
        :items="getFilterMedicoes(filtro)"
        :fields="fields.inspecaoTemplate"
      >
        <template #cell(acoes)="data">
          <div>
            <b-button class="pt-0 pb-0" variant="link" @click="load(data.item)">
              <b-icon icon="file-earmark-arrow-down" variant="info"> </b-icon>
            </b-button>
          </div>
        </template>
      </b-table>
    </div>
    <template #modal-footer>
      <b-form inline>
        <b-icon icon="search" variant="primary" scale="1.2" class="m-1" />
        <b-form-input
          id="med-filter-tmp"
          type="search"
          size="sm"
          variant="warning"
          class="m-1 p-1"
          placeholder="Descrição"
          v-model="filtro"
        />
      </b-form>
      <b-button variant="secondary" @click="show = !show">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { storeToRefs } from "pinia";
import { useTemplateStore } from "@/stores/TemplateStore";
import TableFields from "@/tools/TableFields";
import Medicoes from "@/models_reports/Medicoes";

export default {
  name: "MedicaoTemplateModal",

  data() {
    return {
      show: false,
      fields: new TableFields(),
      template: new Medicoes(),
      filtro: "",
    };
  },

  methods: {
    load(dados) {
      this.template.id = dados.id;
      this.template.descricao = dados.descricao;
      this.template.local = dados.local;
      this.template.posicao = dados.posicao;
      this.template.ano = dados.ano;
      this.template.comprimento = dados.comprimento;
      this.template.perimetro = dados.perimetro;
      this.template.diametro = dados.diametro;
      this.template.pmta = dados.pmta;
      this.template.calotaa = dados.calotaa;
      this.template.calotab = dados.calotab;
      this.template.itens = [];
      this.templateStore.LISTAR_ITENS_MEDICAO(dados.id).then(() => {
        for (var i = 0; i < this.getMedicaoItens.length; i++) {
          this.template.itens.push({
            id: this.getMedicaoItens[i].id,
            a: this.getMedicaoItens[i].a,
            b: this.getMedicaoItens[i].b,
            c: this.getMedicaoItens[i].c,
            d: this.getMedicaoItens[i].d,
            medicao: this.getMedicaoItens[i].medicao,
          });
        }
        this.$emit("loadTemplate", this.template);
        this.show = !this.show;
      });
    },

    call() {
      this.show = !this.show;
    },
  },

  setup() {
    const store = useSgcqStore();
    const templateStore = useTemplateStore();
    const { getMedicaoItens } = storeToRefs(templateStore);
    const { getFilterMedicoes } = storeToRefs(templateStore);

    return {
      store,
      templateStore,
      getMedicaoItens,
      getFilterMedicoes,
    };
  },
};
</script>

<style lang="scss" scoped>
#med-filter-tmp {
  width: 22rem;
}
</style>
